import { motion } from "framer-motion";

const variants = {
  initial: {
    right: '-10%',
    opacity: 0
  },
  animate: {
    height: 0,
    opacity: 1,
    right: '0%',
    transition: {
      duration: 1.25,
      ease: [0.87, 0, 0.13, 1],
    },
  },
};

function ContentImageContainer(props) {
  return (
    <motion.div
      initial="initial"
      animate="animate"
      variants={variants}
      className="relative z-50 bg-black"
    >
      <div className="block px-5 py-5 float-left md:float-right text-center">
        {props.children}
      </div>
    </motion.div>
  );
}

function ContentImage(props) {
  return (
    <ContentImageContainer>
      <img className="object-contain h-96 w-96 py-5" src={props.src} />
      {props.children}
    </ContentImageContainer>
  )
}

export default ContentImage;
